<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" style="border-radius: 5px" @click="cancelApply"
              v-if="isHavePermission('taxOrder:cancelApply')">撤回申请
      </Button>
      <Button type="primary" style="margin-left: 10px;border-radius: 5px" @click="createApplyTax"
              v-if="isHavePermission('taxOrder:createApplyTax')">下载申报单
      </Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px;border-radius: 5px">刷新</Button>
      <div class="search-filter">
        <Poptip placement="top-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="订单编号" field="ordersNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNum" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单类型" field="ordersVersion" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.ordersVersion"
                      :options="ordersVersionListType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务类型" field="busType" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.busType"
                      :options="contractListType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人" field="platformCompanyIds" span="12">
                <template v-slot>
                  <Select
                      v-model="searchPlatIdList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'PlatIdListOption', 'twoOrders', 'searchConditionTax', 3)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'PlatIdListOption')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in PlatIdListOption" :value="option.name" :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人" field="sellerIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerNameOptions', 'twoOrders', 'searchConditionTax', 4)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'sellerNameOptions')"
                      placeholder="输入承运人"
                  >
                    <Option
                        v-for="option in sellerNameOptions"
                        :value="option.name"
                        :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.goodsName" placeholder="输入货名"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运地" field="beginPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.beginPlace"
                      placeholder="输入起运地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达地" field="endPlace" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.endPlace" placeholder="输入车船号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单状态" field="ordersState" span="12">
                <template v-slot>
                  <Select v-model="searchFormData.taxState" placeholder="全部">
                    <Option
                        v-for="option in ordersStateOption"
                        :value="option.value"
                        :key="option.value"
                    >{{ option.label }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="税务机关" field="taxId" span="12">
                <template v-slot>
                  <Select v-model="taxIdList" multiple placeholder="选择税务机关" :max-tag-count="1"
                          :max-tag-placeholder="maxTagPlaceholder">
                    <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="申请人" field="createUserIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'createUserOptions', 'twoOrders', 'searchConditionTax', 7)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
                      placeholder="输入申请人"
                  >
                    <Option
                        v-for="option in createUserOptions"
                        :value="option.id"
                        :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="申请时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      type="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
                  >重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="orderListData"
          :footer-method="footerMethod"
          :filter-config="{ remote: true }"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          resizable
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="90"></vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="130">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.id,row.ordersVersion)">{{ row.ordersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="busType" title="业务类型" width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.busTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="托运人" width="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersVersion === 3 ? row.buyerName : row.compName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人" width="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sellerName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105" align="center"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="150" align="center">
          <template slot-scope="{ row }">
            <a v-if="row.logisticsType === 1" @click="showCarDetail(row)">{{ row.carShipNum }}</a>
            <a v-if="row.logisticsType === 2" @click="showShipDetail(row)">{{ row.carShipNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="150" align="center">
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="150" align="center">
        </vxe-table-column>
        <vxe-table-column field="counts" title="结算数量" width="120" align="center"></vxe-table-column>
        <vxe-table-column field="payAmount" title="应付金额" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="unpayAmount" title="未付金额" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="开票金额" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="taxState" title="订单状态" width="100">
          <template slot-scope="{ row }">
            <span :style="row.taxState === 3 ? 'color:red;':''">{{ row.taxState | taxState }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="taxComp" title="税务机关" width="150"></vxe-table-column>
        <vxe-table-column field="createUser" title="申请人" width="100"></vxe-table-column>
        <vxe-table-column
            field="createTime"
            title="申请时间"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="createCarVisible" :title="createCarTitle" width="1400" height="860" @close="closeCarCreate"
               resize position="center">
      <create-car-modal @afterSave="closeCarCreateModal" ref="modalCarCreate" @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal v-model="createShipVisible" :title="createShipTitle" width="1400" height="900" @close="closeShipCreate"
               resize position="center" destroy-on-close>
      <create-ship-modal @afterSave="closeShipCreateModal" @close="createShipVisible = false"
                         ref="modalShipCreate"></create-ship-modal>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible2"
        title="消息提示"
        width="600"
        height="350"
        @close="closeMessage2"
        position="center"
    >
      <Message2 ref="messageModal2" @close="closeMessage2"></Message2>
    </vxe-modal>
    <vxe-modal v-model="isShowModal" title="设置下载申报单" width="285" height="150" position="center">
      <div style="text-align: center; margin-top: 10px">
        <label>税率: </label>
        <vxe-select v-model="taxRate" placeholder="请选择税率" transfer clearable>
          <vxe-option v-for="(item,index) in tax_rate" :key="index" :value="item.value"
                      :label="item.label"></vxe-option>
        </vxe-select>
      </div>

      <div style="text-align: right; margin-top: 10px">
        <vxe-button type="primary" @click="saveCreateApplyTax">确定</vxe-button>
        <vxe-button type="reset" @click="cancelCreateApplyTax">取消</vxe-button>
      </div>
    </vxe-modal>

  </div>
</template>
<script>
import {formatMoney} from "@/filters/type";
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import moment from "moment";
import $api from "@/apiProvider";
import {getBlob, postBlob, hideLoading, isEmpty, saveBlob, showLoading} from "@/utils/util";
import {SEARCH_TIME} from "@/filters/time";
import Message2 from "@/components/common/Message";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {CreateCarModal, CreateShipModal, Message2},
  mixins: [getAuthOrization],
  data() {
    return {
      taxIdList: [],
      searchPlatIdList: [], // 搜索托运人字段
      buyerNameOptions: [], // 搜索托运人下拉框
      searchSellerName: [], // 搜索承运人字段
      sellerNameOptions: [], // 搜索承运人下拉框
      searchCreateUser: [],
      PlatIdListOption: [],
      createUserOptions: [],
      taxList: [],
      tax_rate: [],
      taxRate: null,
      loading: false, isShowModal: false,
      searchLoading: false,
      orderListData: [],
      ordersStateOption: [
        {
          label: '待审核',
          value: 2,
        }, {
          label: '未通过',
          value: 3,
        }, {
          label: '已通过',
          value: 4,
        }, {
          label: '已开票',
          value: 5,
        },
      ],
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: "",
      createShipTitle: "",
      contractListType: [],
      ordersVersionListType: [
        {label: '委托订单', value: 2},
        {label: '撮合订单', value: 3}
      ],
      timeOptions: SEARCH_TIME.options,
      searchVisible: false,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      searchFormData: {
        ordersNum: null,
        busType: null,
        taxState: null, // 订单状态
        auditState: null,
        goodsName: null,
        carShipNum: null,
        beginPlace: null,
        beginTime: null,
        endPlace: null,
        endTime: null,
        buyerIdList: null,
        sellerIdList: null,
        createTime: null,
      },
      records: [],
      open: false,
      paramsObj: {
        page: 1,
        rows: 10,
      },
      messageVisible2: false,
    };
  },
  watch: {
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  filters: {
    taxState(val) {
      if (val != null) {
        if (val === 1) {
          return "待申请";
        }
        if (val === 2) {
          return "待审核";
        }
        if (val === 3) {
          return "未通过";
        }
        if (val === 4) {
          return "已通过";
        }
        if (val === 5) {
          return "已开票";
        }
      }
    },
  },
  mounted() {
    this.getDictDate();
    this.getTaxList();
    this.getDictByCode(603, "tax_rate");
  },
  methods: {
    closeMessage2() {
      this.messageVisible2 = false;
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          if (code === 603) {
            arr.push({
              label: i.dictText + "%",
              value: i.dictText,
            });
          }
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getTaxList() {
      let res = await $api.tax.post('getTaxList', {});
      if (res.status === 1) {
        this.taxList = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async createApplyTax() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: "请选择至少一条订单信息",
          status: "error",
        });
        return;
      }
      this.isShowModal = true;
    },
    cancelCreateApplyTax() {
      this.taxRate = null;
      this.isShowModal = false;
    },

    async saveCreateApplyTax() {
      if (this.taxRate === null || this.taxRate === "") {
        this.$XModal.alert({
          message: "请选择税率",
          status: "error",
        });
        return;
      }
      let records = this.records;
      let idList = [];
      records.map((i) => {
        idList.push(i.id);
      });
      showLoading();
      let res = postBlob("/api/order/twoOrders/orders/createApplyTax", {
        ordersIdList: idList,
        taxRate: this.taxRate
      });
      // let res = getBlob("/api/order/twoInvoice/exportInvoiceList", params);
      hideLoading();
      this.records = [];
      this.refresh();
      this.taxRate = null;
      this.isShowModal = false;
    },

    async cancelApply() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: "请选择至少一条订单信息",
          status: "error",
        });
        return;
      }
      let sameV = false;
      let v = records[0].ordersVersion;
      records.map((i) => {
        if (i.ordersVersion !== v) {
          sameV = true;
        }
      });
      if (sameV) {
        this.$XModal.alert({
          message: "批量撤回的订单必须为同一订单类型！",
          status: "error",
        });
        return
      }

      let idList = [];
      records.map((i) => {
        idList.push(i.id);
      });
      showLoading();
      let res;
      if (v === 2) {
        res = await $api.twoOrders.post("applyTaxCallBack", {
          ordersIdList: idList,
        });
      } else {
        res = await $api.matchOrder.post('applyTaxCallBackMatch', {
          ordersIdList: idList,
        });
      }

      hideLoading();
      if (res.status === 1) {
        this.$Message.success("撤回成功");
        this.records = [];
        this.refresh();
      } else {
        let data = res.data;
        let message = "";
        if (data.length > 0) {
          data.map((i) => {
            message = message + '序号' + i.failArrayIndex + '，' + i.failMsg + "\n";
          });
        }
        if (message === "") {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal2.setMessage(message);
          this.messageVisible2 = true;
        }
      }
    },
    refresh() {
      this.records = [];
      this.getListData(this.paramsObj);
    },
    async getListData(obj) {
      let params = obj
          ? obj
          : {
            page: this.page.currentPage,
            rows: this.page.pageSize,
          };
      this.loading = true;
      let res = await $api.twoOrders.post("getTaxOrderlist", params);
      this.loading = false;
      if (res.status === 1) {
        this.countRtnVo = res.data.countRtnVo;
        this.page.totalResult = res.data.total;
        this.orderListData = res.data.rows;
        this.orderListData.map((i) => {
          if (i.busType) {
            this.contractListType.map((j) => {
              if (j.value === parseInt(i.busType)) {
                i.busTypeText = j.label;
              }
            });
          }
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getDictDate() {
      this.contractListType = [];
      $api.other.getOrderBusTypeModelTwo
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.encoded),
              };
              this.contractListType.push(obj);
            });

            this.getListData();
          });
    },
    openOrderDetail(id, ordersVersion) {
      if (ordersVersion === 2) {
        let obj = {
          name: `订单详情2.0-${id}`,
          path: `/tax/taxOrderdetail/${id}`,
        };
        window.open(obj.path);
      } else {
        let obj = {
          name: `订单详情2.0-${id}`,
          path: `/tax/taxOrderdetail/true/${id}`,
        };
        window.open(obj.path);
      }

      return false;
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};

      Object.keys(obj).forEach((key) => {
        if (
            obj[key] !== null &&
            key !== "createTime" &&
            obj[key] !== undefined
        ) {
          paramsObj[key] = obj[key];
        }

        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      paramsObj.orderBy = 6;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      if (this.searchPlatIdList.length > 0) {
        paramsObj.buyerNameList = this.searchPlatIdList;
      }
      if (this.searchSellerName.length > 0) {
        paramsObj.sellerNameList = this.searchSellerName;
      }
      if (this.searchCreateUser.length > 0) {
        paramsObj.createUserIdList = this.searchCreateUser;
      }

      if (this.taxIdList.length > 0) {
        paramsObj.taxIds = this.taxIdList;
      }

      this.paramsObj = paramsObj;
      this.getListData(paramsObj);
      this.searchVisible = false;
    },
    reset() {
      this.searchPlatIdList = []; // 搜索托运人字段
      this.searchSellerName = []; // 搜索承运人字段
      this.searchCreateUser = []; // 搜索创建人字段
      this.taxIdList = [];

      this.taxRate = null;
      this.searchFormData = {
        ordersNum: null,
        busType: null,
        taxState: null, // 订单状态
        auditState: null,
        goodsName: null,
        carShipNum: null,
        beginPlace: null,
        beginTime: null,
        endPlace: null,
        endTime: null,
        buyerIdList: null,
        sellerIdList: null,
        createTime: null,
      };
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      // console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    handlePageChange(e) {
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.getListData(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getListData();
      }
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "单页合计";
          }
          if (
              ["counts"].includes(column.property)
          ) {
            return this.$utils.sum(data, column.property);
          }
          if (
              ["payedAmount"].includes(column.property)
          ) {
            return formatMoney(this.$utils.sum(data, column.property));
          }
          if (
              ["invoiceAmount"].includes(column.property)
          ) {
            return formatMoney(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "全部合计";
          }
          if (["counts"].includes(column.property) && this.countRtnVo) {
            return this.countRtnVo.totalCounts;
          }
          if (["payedAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalPayedAmount);
          }
          if (["invoiceAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalInvoiceAmount);
          }
          return null;
        }),
      ];
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = "查看车辆信息";
        this.createCarVisible = true;
        this.$nextTick(() => {
          this.$refs.modalCarCreate.init();
          this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
          this.$refs.modalCarCreate.setReadOnly();
          this.$refs.modalCarCreate.setNoUpdate();
        });
      } else {
        this.$XModal.alert({
          message: "暂无车辆信息",
          status: "error",
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = "查看船舶信息";
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
          this.$refs.modalShipCreate.setNoUpdate();
        });
      } else {
        this.$XModal.alert({
          message: "暂无船舶信息",
          status: "error",
        });
      }
    },
    closeCarCreateModal(type) {
      this.createCarVisible = false;
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
      // this.queryLogisticsList();
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    },
  }
}
</script>
<style>
.ivu-tag-text {
  max-width: 100px;
}
</style>